import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  PreviousPeriodPayload,
  PreviousPeriodsLoadResponse,
} from '../components/main/spreading/models/models';
import { ApiService } from './api.service';

/**
 * Wraps the three /previous-periods endpoints used by the redesigned
 * spreading page's "previous periods in data categorization" feature.
 *
 * The feature ships as part of the Data Categorization redesign, which is
 * gated at the route by the `data-categorization-redesign` LaunchDarkly flag.
 */
@Injectable()
export class PreviousPeriodsService {
  constructor(private apiService: ApiService) {}

  /** Combined load: candidate prior periods + default + persisted user selection. */
  load(statementUuid: string): Observable<PreviousPeriodsLoadResponse> {
    return this.apiService
      .send('Get', `/api/statements/${statementUuid}/previous-periods`, null)
      .pipe(map(data => data.response.objects[0] as PreviousPeriodsLoadResponse));
  }

  /** Fetch the column + source-row payload for a list of period keys. */
  resolve(
    statementUuid: string,
    periodKeys: Array<string>,
  ): Observable<Array<PreviousPeriodPayload>> {
    return this.apiService
      .send(
        'Post',
        `/api/statements/${statementUuid}/previous-periods/resolve`,
        { period_keys: periodKeys },
      )
      .pipe(map(data => (data.response.objects[0]?.periods || []) as Array<PreviousPeriodPayload>));
  }

  /** Persist the user's period-selection for a given document file. */
  saveSelection(
    documentFileId: number,
    selectedPeriodKeys: Array<string>,
  ): Observable<Array<string>> {
    return this.apiService
      .send(
        'Put',
        `/api/documentfiles/${documentFileId}/period-selections`,
        { selected_period_keys: selectedPeriodKeys },
      )
      .pipe(map(data => (data.response.objects[0]?.selectedPeriodKeys || []) as Array<string>));
  }
}
